import { ValidationType } from './ValidationType';
import { BetResponseCode } from '@pascal/pascal-core/shared/core/enums/ResponseCodes';

export const BetResponseCodes = {
  [ValidationType.InvalidToken]: BetResponseCode.InValidToken,
  [ValidationType.InvalidSpin]: BetResponseCode.InvalidBet,
  [ValidationType.MoneyTransactionError]: BetResponseCode.MoneyTransactionError,
  [ValidationType.NotEnoughMoney]: BetResponseCode.InsufficientFunds,
  [ValidationType.SpinNotFound]: BetResponseCode.ResultNotFound,
  [ValidationType.Success]: BetResponseCode.Success,
  [ValidationType.PartnerNotFound]: BetResponseCode.PartnerGameConfigNotFound,
  [ValidationType.InvalidSpinResult]: BetResponseCode.ResultNotFound,
  [ValidationType.InvalidOperation]: BetResponseCode.ResultNotFound,
  [ValidationType.InvalidAmount]: BetResponseCode.InValidBetData,
  [ValidationType.InvalidSpinCount]: BetResponseCode.ResultNotFound,
  [ValidationType.PlayerLimitExceeded]: BetResponseCode.PlayerLimitExceeded
}

